import { useAppContext } from '@/context/app';
import { isMatchMobileMedia } from '@/util/is-match-mobile-media';
import debounce from 'lodash.debounce';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

let prevHeadStickedOnTop: null | boolean = null;

const HeaderRectCalculate = (props: {
  headerToolbarRef: { current: HTMLElement | null };
  mobileHeaderMenuRef: {
    current: HTMLElement | null;
  };
  headerId: string;
  getShouldResetHeaderOnTop: () => boolean;
  setShouldResetHeaderOnTop: (nextState: boolean) => void;
}) => {
  const { headerToolbarRef, mobileHeaderMenuRef, headerId, getShouldResetHeaderOnTop, setShouldResetHeaderOnTop } =
    props;

  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [
    ,
    {
      actions: { toggleHeaderOnTop, setHeaderToolbarHeight, setHeaderHeight },
    },
  ] = useAppContext();
  const isWhoIsYourCharacterGame = pathname === '/who-is-your-character';

  useEffect(() => {
    const calculateHeaderRect = () => {
      const headerToolBarElement = headerToolbarRef.current;
      const mobileHeaderMenu = mobileHeaderMenuRef.current;
      const header = document.getElementById(headerId);

      if (headerToolBarElement) {
        setHeaderToolbarHeight(
          headerToolBarElement.offsetHeight - (isMatchMobileMedia() ? mobileHeaderMenu?.offsetHeight || 0 : 0) || 0,
        );
      }

      if (header) {
        setHeaderHeight(header.offsetHeight);
      }
    };

    calculateHeaderRect();

    const resizeHandler = debounce(calculateHeaderRect, 500);

    window.addEventListener('resize', resizeHandler);

    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, [
    setHeaderToolbarHeight,
    pathname,
    searchParams,
    setHeaderHeight,
    headerId,
    headerToolbarRef,
    mobileHeaderMenuRef,
  ]);

  useEffect(() => {
    const isStickedOnTop = window.scrollY === 0;

    if (prevHeadStickedOnTop === isStickedOnTop) return;

    toggleHeaderOnTop(isStickedOnTop);
    prevHeadStickedOnTop = isStickedOnTop;
  }, [pathname, searchParams, toggleHeaderOnTop]);

  useEffect(() => {
    if (isWhoIsYourCharacterGame) return;

    const scrollHandler = () => {
      const isStickedOnTop = window.scrollY === 0;

      if (prevHeadStickedOnTop === isStickedOnTop && !getShouldResetHeaderOnTop()) return;

      toggleHeaderOnTop(isStickedOnTop);
      prevHeadStickedOnTop = isStickedOnTop;
      setShouldResetHeaderOnTop(false);
    };

    document.addEventListener('scroll', scrollHandler);

    return () => {
      document.removeEventListener('scroll', scrollHandler);
    };
  }, [toggleHeaderOnTop, getShouldResetHeaderOnTop, setShouldResetHeaderOnTop, isWhoIsYourCharacterGame]);

  return null;
};

export default HeaderRectCalculate;
